<template>
  <div class="physioDrugDetail">
    <el-dialog
      title="编辑商品信息"
      :visible.sync="visible"
      width="960px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="close">
      <div class="content" v-loading="loading">
        <el-form ref="form" class="form" :model="form" label-width="100px">
          <div class="section">
            <div class="section_header">
              <div class="section_header_title">项目基本信息</div>
            </div>
            <div class="section_info">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="货号：">
                    <span class="section_text">{{ form.artNo }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="商品名称：">
                    <span class="section_text">{{ form.physioKindName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位：">
                    <span class="section_text">{{ form.unit || '-' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="section">
            <div class="section_header">
              <div class="section_header_title">项目操作信息</div>
            </div>
            <div class="section_info">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="所属大类：" prop="firstCategory.categoryId">
                    <span class="section_text">{{ form.firstCategory.physioLabel || '-' }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所属小类：" prop="secondCategory.categoryId">
                    <span class="section_text">{{ form.secondCategory.physioLabel || '-' }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="服务时长：" prop="serviceTime">
                    <span class="section_text">{{ ['', null, undefined].includes(form.serviceTime) ? '-' : `${form.serviceTime}分钟` }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="标准时长：" prop="executeTime">
                    <span class="section_text">{{ ['', null, undefined].includes(form.executeTime) ? '-' : `${form.executeTime}分钟` }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="form.specialConfigs.length > 0" class="special">
                <div class="special_label">
                  <el-form-item class="special_label_item" label="特定时长："></el-form-item>
                </div>
                <div class="special_tips">当医生操作时长与平台标准不一致时，可在此为特定医师单独设定操作时长</div>
                <div class="special_list">
                  <div v-for="(special, specialIndex) in form.specialConfigs" :key="special.vId" class="special_item">
                    <div class="special_item_left">
                      <el-form-item class="special_item_form_item" label-width="0px" :show-message="false" :prop="`specialConfigs[${specialIndex}].doctorId`" :rules="{ required: true }">
                        <span class="section_text">{{ special.doctorName }}</span>
                      </el-form-item>
                      <el-form-item class="special_item_form_item" label-width="0px" :show-message="false" :prop="`specialConfigs[${specialIndex}].executeTime`" :rules="{ required: true }">
                        <span class="section_text">{{ special.executeTime }}分钟</span>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getPhysioConfigByArtNo } from '@/api/physio.js'

  export default {
    name: 'physioDrugDetail',
    data () {
      return {
        visible: false,
        loading: false,
        form: {
          spu: '',
          artNo: '',
          physioKindName: '',
          unit: '',
          firstCategory: {
            categoryId: '',
            physioLabel: ''
          },
          secondCategory: {
            categoryId: '',
            physioLabel: ''
          },
          serviceTime: '',
          executeTime: '',
          specialConfigs: []
        }
      }
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      async getDetail () {
        this.loading = true
        const res = await getPhysioConfigByArtNo({ spu: this.form.spu })
        this.loading = false
        if (res.code === 200) { 
          this.form.artNo = res.data.artNo || ''
          this.form.physioKindName = res.data.physioKindName || ''
          this.form.unit = res.data.unit || ''
          
          this.form.firstCategory.categoryId = res.data.firstCategory && res.data.firstCategory.categoryId || ''
          this.form.firstCategory.physioLabel = res.data.firstCategory && res.data.firstCategory.physioLabel || ''
          this.form.secondCategory.categoryId = res.data.secondCategory && res.data.secondCategory.categoryId || ''
          this.form.secondCategory.physioLabel = res.data.secondCategory && res.data.secondCategory.physioLabel || ''

          this.form.serviceTime = ['', null, undefined].includes(res.data.serviceTime) ? '' : res.data.serviceTime
          this.form.executeTime = ['', null, undefined].includes(res.data.executeTime) ? '' : res.data.executeTime
          this.form.specialConfigs = res.data.specialConfigs && res.data.specialConfigs.map(v => {
            return { ...v, vId: this.generateUUID() }
          }) || []
        }
      },

      async open (spu) {
        this.visible = true
        this.form.spu = spu
        this.getDetail()
      },
      close () {
        this.visible = false
        this.form.spu = ''
        this.form.artNo = ''
        this.form.physioKindName = ''
        this.form.unit = ''
        this.form.firstCategory.categoryId = ''
        this.form.firstCategory.physioLabel = ''
        this.form.secondCategory.categoryId = ''
        this.form.secondCategory.physioLabel = ''
        this.form.serviceTime = ''
        this.form.executeTime = ''
        this.form.specialConfigs = []
      },
    }
  }
</script>

<style lang="less" scoped>
  .physioDrugDetail /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .physioDrugDetail /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .physioDrugDetail /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .physioDrugDetail /deep/ .el-dialog__body {
    padding: 0;
  }

  .physioDrugDetail /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .content {
    padding: 20px;
    max-height: 500px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .form {
    overflow: hidden;
  }

  .form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #333333;
  }

  .form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .section {
    width: 100%;
  }

  .section_header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .section_header_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
  }

  .section_header_title::before {
    content: '';
    display: block;
    margin: 0 8px 0 0;
    width: 3px;
    height: 16px;
    background-color: #1890FF;
    border-radius: 2px;
  }

  .section_info {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .special_label_item {
    margin-bottom: 0px;
  }

  .special_tips {
    margin: 4px 0 0 0;
    line-height: 22px;
    font-size: 12px;
    color: #999999;
  }

  .special_list {
    box-sizing: border-box;
    margin: 8px 0 0 0;
    padding: 12px 16px;
    width: 610px;
    background-color: #F5F7FA;
  }

  .special_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .special_item+.special_item {
    margin: 16px 0 0 0;
  }

  .special_item_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .special_item_form_item {
    margin-bottom: 0px;
    width: 140px;
  }

  .special_item_form_item+.special_item_form_item {
    margin-left: 24px;
  }

</style>